import { MockEntityObjectCreator } from "@/testing";
import { Team } from "@/types/types";
import { findUnusedColor, getTeamColorOptions } from "@/utils/teamColorPalette";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EventFormSectionStyles } from "./SectionStyles";

@customElement("teams-section")
export class TeamsSection extends LitElement {
	static readonly styles = [EventFormSectionStyles, css`
        .form-row {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    `];

	@property({ type: Array }) values: Team[] = [];

	private mockEntityObjectCreator = new MockEntityObjectCreator();

	constructor() {
		super();
		this.addEventListener('team-color-change', this._handleTeamColorChange as EventListener);
	}

	private readonly _handleTeamColorChange = (event: CustomEvent<{ teamIndex: number; newColor: string }>) => {
		const { teamIndex, newColor } = event.detail;
		const previousColor = this.values[teamIndex].color;

		const teamWithSameColorIndex = this.values.findIndex(
			(team, index) => index !== teamIndex && team.color === newColor
		);

		this.values[teamIndex] = { ...this.values[teamIndex], color: newColor };

		if (teamWithSameColorIndex !== -1) {
			this.values[teamWithSameColorIndex] = { ...this.values[teamWithSameColorIndex], color: previousColor };
		}

		this.requestUpdate();
	};

	private readonly addTeam = () => {
		const newTeam = this.mockEntityObjectCreator.createEmptyTeam(this.values.length + 1);
		const usedColors = this.values.map(team => team.color);
		if (usedColors.includes(newTeam.color)) {
			const allColors = getTeamColorOptions().map(option => option.value);
			newTeam.color = findUnusedColor(usedColors, allColors) ?? newTeam.color;
		}

		this.values.push(newTeam);
		this.requestUpdate();
	};

	private _getSortedTeams(): Team[] {
		return [...this.values].sort((a, b) => a.team_number - b.team_number);
	}

	render() {
		const sortedTeams = this._getSortedTeams();

		return html`
            <div class="form-section">
                <p class="form-section-title">👥 Teams und Spieler</p>
                <div class="form-row">
                    ${sortedTeams.map((team, index) => html`
                        <add-team-card 
                            .teamIndex="${this.values.indexOf(team)}"
                            .team="${team}"
                        ></add-team-card>
                    `)}
                </div>
                <basic-button @click="${this.addTeam}">
                    ➕ Team hinzufügen
                </basic-button>
            </div>
        `;
	}
}

export default TeamsSection;